import { BrowserRouter, Routes, Route } from "react-router-dom";

import LoginHotel from "./components/LoginHotel";
import LoginNgo from "./components/loginNgo";
import RegisterForm from "./components/RegisterForm";
import Dashboard from "./components/Dashboard";
import AboutUs from "./components/About";
 
import HotelDashboard from "./components/HotelDashboard";
import AddSurplus from "./components/AddSurplus";   
import NgoDashboard from "./components/NgoDashboard";
import HotelAccount from "./components/HotelAccount";
import HotelDonationEvent from "./components/DonationEvent";
import CollectedFood from "./components/CollectedFood";
import AvailableSurplus from "./components/AvailableSurplus";
import NgoAccount from "./components/NgoAccount";
import ReportPage from "./components/ReportPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Front Page */}
        <Route path="/" element={<Dashboard />} />

        

        {/* Hotel */}
        <Route path="/hotel/login" element={<LoginHotel />} />
        <Route path="/hotel/dashboard" element={<HotelDashboard />} />
        <Route path="/hotel/add-surplus" element={<AddSurplus />} />  

        {/* NGO */}
        <Route path="/ngo/login" element={<LoginNgo />} />

        {/* Register */}
        <Route path="/register" element={<RegisterForm />} />

        { /* ngo dashboard */ }
        <Route path="/ngo/dashboard" element={<NgoDashboard />} />

        { /* hotel account */}
        <Route path="/hotel/account" element={<HotelAccount />} />

        { /* hotel donation */}
        <Route path="/hotel/donationevent" element={<HotelDonationEvent />} />

        { /* collected food */}
        <Route path="/ngo/collectedfood" element={<CollectedFood />} />

          {/* AVAILABLE SURPLUS (COLLECT FOOD) */}
        <Route path="/ngo/collectfood" element={<AvailableSurplus />} />

        {/* About Us */ }
        <Route path="/about" element={<AboutUs />} />

        {/* NGO Account */}
        <Route path="/ngo/account" element={<NgoAccount />} />

        {/* Report Page */}
        <Route path="/report" element={<ReportPage />} />

        

      </Routes>
    </BrowserRouter>
  );
}

export default App;
